"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
Name={"Close"} 
Color={"white"} Size={24} 

optional:
Align={"right"} OnClick={() => {this.Close() }} Style={{cursor: 'pointer'}} Tooltip={}
*/

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon(props) {
    _classCallCheck(this, Icon);

    var _this = _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).call(this, props));

    _this.state = {};
    _this.state.Name = _this.props.Name;
    _this.state.Color = _this.props.Color;
    _this.state.Size = _this.props.Size;
    _this.state.Tooltip = _this.props.Tooltip;
    _this.state.Title = _this.props.Title;
    _this.state.OnClick = _this.props.OnClick;
    _this.state.ClassName = _this.props.ClassName;
    _this.state.For = _this.props.For;
    _this.state.Id = _this.props.Id;
    return _this;
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var path = "";
      var float = "left";
      var cursor = "";
      var Tooltip = "";
      var controlClassName = "icon";

      if (this.state.ClassName) {
        controlClassName = this.state.ClassName;
      }
      if (this.state.Tooltip && this.state.Tooltip !== "") {
        Tooltip = _react2.default.createElement(
          "span",
          { id: this.props.Id + "Tooltip" },
          this.state.Tooltip
        );
      }

      if (this.props.Align) {
        float = this.props.Align;
      }

      if (this.props.OnClick) {
        {
          cursor = "pointer";
        }
      }

      var Color = this.state.Color;
      var Size = this.state.Size;

      switch (this.state.Name) {
        case "Logo":
          path = "images/vsa_icon.png";
          break;
        case "SignOut":
          path = "images/icons/" + Color + "/" + Size + "/ic_power_settings_new.svg";
          break;
        case "Menue":
        case "Menu":
          path = "images/icons/" + Color + "/" + Size + "/ic_dehaze.svg";
          break;
        case "MenuCustomerCard":
          path = "images/icons/" + Color + "/" + Size + "/ic_arrow_down.svg";
          break;
        case "Account":
          path = "images/icons/" + Color + "/" + Size + "/ic_account_circle.svg";
          break;
        case "Search":
          path = "images/icons/" + Color + "/" + Size + "/ic_search.svg";
          break;
        case "Schools":
          path = "images/icons/" + Color + "/" + Size + "/ic_school.svg";
          break;
        case "Settings":
          path = "images/icons/" + Color + "/" + Size + "/ic_settings.svg";
          break;
        case "Home":
          path = "images/icons/" + Color + "/" + Size + "/ic_home.svg";
          break;
        case "Forms":
          path = "images/icons/" + Color + "/" + Size + "/ic_assignment.svg";
          break;
        case "Templates":
          path = "images/icons/" + Color + "/" + Size + "/ic_dashboard.svg";
          break;
        case "Customers":
          path = "images/icons/" + Color + "/" + Size + "/ic_supervisor_account.svg";
          break;
        case "Contracts":
          path = "images/icons/" + Color + "/" + Size + "/ic_description.svg";
          break;
        case "Tasks":
          path = "images/icons/" + Color + "/" + Size + "/ic_assignment.svg";
          break;
        case "Delete":
          path = "images/icons/" + Color + "/" + Size + "/ic_delete.svg";
          break;
        case "Administration":
          path = "images/icons/" + Color + "/" + Size + "/ic_build.svg";
          break;
        case "Kalender":
          path = "images/icons/" + Color + "/" + Size + "/ic_date_range.svg";
          break;
        case "Warning":
          path = "images/icons/" + Color + "/" + Size + "/ic_warning.svg";
          break;
        case "Done":
          path = "images/icons/" + Color + "/" + Size + "/ic_done.svg";
          break;
        case "ArrowUp":
          path = "images/icons/" + Color + "/" + Size + "/ic_arrow_drop_up.svg";
          break;
        case "ArrowDown":
          path = "images/icons/" + Color + "/" + Size + "/ic_arrow_drop_down.svg";
          break;
        case "Close":
          path = "images/icons/" + Color + "/" + Size + "/ic_baseline_close.svg";
          break;
        case "Create":
          path = "images/icons/" + Color + "/" + Size + "/ic_create.svg";
          break;
        case "Loop":
          path = "images/icons/" + Color + "/" + Size + "/ic_loop.svg";
          break;
        case "Download":
          path = "images/icons/" + Color + "/" + Size + "/ic_download.svg";
          break;
        case "Add":
          path = "images/icons/" + Color + "/" + Size + "/ic_add.svg";
          break;
        case "Left":
          path = "images/icons/" + Color + "/" + Size + "/ic_left.svg";
          break;
        case "Right":
          path = "images/icons/" + Color + "/" + Size + "/ic_right.svg";
          break;
        case "FirstPage":
          path = "images/icons/" + Color + "/" + Size + "/ic_first_page.svg";
          break;
        case "LastPage":
          path = "images/icons/" + Color + "/" + Size + "/ic_last_page.svg";
          break;
        case "Upload":
          path = "images/icons/" + Color + "/" + Size + "/ic_note_add.svg";
          break;
        case "Lost":
          path = "images/icons/" + Color + "/" + Size + "/ic_lost.svg";
          break;
        case "Remove":
          path = "images/icons/" + Color + "/" + Size + "/ic_remove.svg";
          break;
        case "FlagGermany":
          path = "images/icons/flags/flag_germany.png";
          break;
        case "FlagUnitedKingdom":
          path = "images/icons/flags/flag_united_kingdom.png";
          break;
        case "FlagEngland":
          path = "images/icons/flags/flag_england.png";
          break;
        case "Person":
          path = "images/icons/" + Color + "/" + Size + "/ic_person.svg";
          break;
        case "Language":
          path = "images/icons/" + Color + "/" + Size + "/ic_language.svg";
          break;
        case "KeyboardArrowRight":
          path = "images/icons/" + Color + "/" + Size + "/ic_keyboard_arrow_right.svg";
          break;
        case "KeyboardArrowDown":
          path = "images/icons/" + Color + "/" + Size + "/ic_keyboard_arrow_down.svg";
          break;
        case "DownloadFile":
          path = "images/icons/" + Color + "/" + Size + "/ic_download_file.svg";
          break;
        case "UploadFile":
          path = "images/icons/" + Color + "/" + Size + "/ic_upload_file.svg";
          break;
        case "Clear":
          path = "images/icons/" + Color + "/" + Size + "/ic_clear.svg";
          break;

        default:
          path = "";
      }
      if (path.length > 0) {
        return _react2.default.createElement(
          "div",
          {
            style: { float: float, paddingLeft: this.props.PaddingLeft, paddingTop: this.props.PaddingTop, paddingRight: this.props.PaddingRight },
            className: controlClassName },
          _react2.default.createElement("img", {
            style: { cursor: cursor },
            id: this.state.Id === undefined ? this.state.Name === "Done" ? "OK" : this.state.Name : this.state.Id,
            src: document.location.origin + "/" + path,
            alt: this.state.Name === "Done" ? "OK" : this.state.Name,
            onClick: function onClick(e) {
              if (_this2.props.OnClick) {
                _this2.props.OnClick(e);
              }
            },
            title: this.state.Title
            //htmlFor={this.state.For} 
          }),
          Tooltip
        );
      } else {
        return _react2.default.createElement("div", {
          style: { float: float, paddingLeft: this.props.PaddingLeft, paddingTop: this.props.PaddingTop, paddingRight: this.props.PaddingRight },
          className: controlClassName });
      }
    }
  }]);

  return Icon;
}(_react.Component);

exports.default = Icon;